module.exports = __webpack_public_path__ + "assets/img/modal-avatar-0df2a1c9.png";